import { provideSingleton } from '../../../inversify';

@provideSingleton(Theme)
class Theme {
    public getLineColor(line: string, darker?: boolean) {
        if (line === '881' || line === '1') {
          return 'lineBlue';
        } else if (line === '882' || line === '2') {
          return 'lineRed';
        } else if (line === '883' || line === '3') {
          return (darker)?'lineYellowDarker':'lineYellow';
        } else if (line === '884' || line === '4') {
          return (darker)?'lineGreenDarker':'lineGreen';
        } else if (line === '885' || line === '5') {
          return (darker)?'lineGrayDarker':'lineGray';
        } else {
          return 'lineBlack';
        }
      }
}

export default Theme;


// WEBPACK FOOTER //
// ./src/components/stadtbus/css/bustheme.ts